import { createContext } from 'react';
import { RecipientAlertService } from './RecipientAlertService';
import { UserAlertService } from './UserAlertService';

export const userAlertsService = new UserAlertService();
export const recipientAlertService = new RecipientAlertService();
interface AlertsAPIContextType {
  APIService: UserAlertService | RecipientAlertService;
  activeRecipientID: string | undefined;
}

export const AlertsAPIservice = createContext<AlertsAPIContextType>({
  APIService: userAlertsService,
  activeRecipientID: undefined
});
